export default [
  {
    path: '/app/projects-video-gallery',
    name: 'ProjectsVideoGallery',
    component: () => import('@/views/Admin/ProjectsVideoGallery/Index.vue'),
    meta: {
      pageTitle: 'Video Galerisi',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PROJECTS_VIDEO_GALLERY',
      action: 'read',
    },
  },
  // {
  //   path: '/app/projects-video-gallery/add',
  //   name: 'VideoGalleryAdd',
  //   component: () => import('@/views/Admin/ProjectsVideoGallery/Add.vue'),
  //   meta: {
  //     pageTitle: 'Video Galerisi',
  //     breadcrumb: [
  //       {
  //         text: 'Liste',
  //         to: '/app/projects-video-gallery',
  //         active: false,
  //       },
  //       {
  //         text: 'Oluştur',
  //         active: true,
  //       },
  //     ],
  //     resource: 'ADMIN_PROJECTS_VIDEO_GALLERY',
  //     action: 'read',
  //   },
  // },
  // {
  //   path: '/app/projects-video-gallery/edit/:id',
  //   name: 'VideoGalleryEdit',
  //   component: () => import('@/views/Admin/ProjectsVideoGallery/Edit.vue'),
  //   meta: {
  //     pageTitle: 'Video Galerisi',
  //     breadcrumb: [
  //       {
  //         text: 'Liste',
  //         to: '/app/projects-video-gallery',
  //         active: false,
  //       },
  //       {
  //         text: 'Güncelle',
  //         active: true,
  //       },
  //     ],
  //     resource: 'ADMIN_PROJECTS_VIDEO_GALLERY',
  //     action: 'read',
  //   },
  // },
]
